/**
 * ProgressRing — the thin arc around the dock's glyph.
 *
 * An SVG stroke-dashoffset arc rather than a conic gradient: a conic has a
 * hard edge, cannot round its cap, and jumps between values instead of
 * sweeping. This starts at twelve o'clock, carries a round cap, and eases to
 * its new length whenever a step completes — so earning a Neuron is something
 * you can see happen rather than something you notice afterwards.
 *
 * Colour comes from `currentColor` on each circle, so light and dark themes
 * need no branch here.
 */

const VIEWBOX = 100;
const STROKE = 7;
const RADIUS = (VIEWBOX - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
/** SVG circles start at 3 o'clock; progress should start at the top. */
const ROTATION_DEG = -90;

export function ProgressRing({ progress }: { progress: number }) {
  const clamped = Math.min(1, Math.max(0, progress));
  const c = VIEWBOX / 2;
  return (
    <svg
      viewBox={`0 0 ${VIEWBOX} ${VIEWBOX}`}
      className="journey-ring-svg"
      aria-hidden
    >
      <circle
        cx={c} cy={c} r={RADIUS} fill="none" stroke="currentColor"
        strokeWidth={STROKE} className="journey-ring-track"
      />
      <circle
        cx={c} cy={c} r={RADIUS} fill="none" stroke="currentColor"
        strokeWidth={STROKE} strokeLinecap="round"
        strokeDasharray={CIRCUMFERENCE}
        strokeDashoffset={CIRCUMFERENCE * (1 - clamped)}
        transform={`rotate(${ROTATION_DEG} ${c} ${c})`}
        className="journey-ring-arc"
      />
    </svg>
  );
}
